import React from 'react';
import PageBackBar from '../PageBackBar';
import BackButton from '../BackButton';

/**
 * Standalone back navigation row — sits above PageHeaderSection with list-page spacing between.
 */
export default function PageBackSection({ backTo = null, className = '' }) {
    return (
        <div className={`page-back-section ${className}`.trim()}>
            {backTo ? <BackButton to={backTo} /> : <PageBackBar />}
        </div>
    );
}
